module.exports = __webpack_public_path__ + "img/water-mark.09c3791a.jpg";